import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-assistant-sidebar',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './assistant-sidebar.component.html',
  styleUrls: ['./assistant-sidebar.component.scss'],
})
export class AssistantSidebarComponent implements OnChanges {
  /** Whether the sidebar is open */
  @Input() isOpen = false;

  /** Header title */
  @Input() sidebarTitle = 'AI Assistant';

  /** When false, the title row is hidden (e.g. empty chat where the hero shows the name). */
  @Input() showTitle = true;

  /** Width of the sidebar panel in pixels */
  @Input() width = 440;

  /** Show the "New chat" button in the header */
  @Input() showNewChat = false;

  /** Show the "Cancel" button in the header */
  @Input() showCancel = false;

  /** Emitted when the sidebar should close */
  @Output() sidebarClose = new EventEmitter<void>();

  /** Emitted when the "New chat" button is clicked */
  @Output() newChatClick = new EventEmitter<void>();

  /** Emitted when the "Cancel" button is clicked */
  @Output() cancelClick = new EventEmitter<void>();

  /** Total track width: panel width plus 8px horizontal padding on each side. */
  @HostBinding('style.width.px')
  get hostWidth(): number | null {
    return this.isOpen ? this.width + 16 : null;
  }

  @HostBinding('style.padding')
  get hostPadding(): string {
    return this.isOpen ? '0 8px' : '0';
  }

  /** Whether the shimmer animation is playing */
  shimmerActive = false;

  private shimmerTimeout: ReturnType<typeof setTimeout> | null = null;

  /** Close on Escape key */
  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.isOpen) {
      this.sidebarClose.emit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue === true && !changes['isOpen']?.previousValue) {
      // Clear any pending timeout from a previous open
      if (this.shimmerTimeout) {
        clearTimeout(this.shimmerTimeout);
      }

      // Activate shimmer, then remove the class after the animation finishes
      // (0.3s delay + 1.4s duration = 1.7s total)
      this.shimmerActive = true;

      this.shimmerTimeout = setTimeout(() => {
        this.shimmerActive = false;
        this.shimmerTimeout = null;
      }, 1800);
    }
  }
}
